import Layout from '@modules/layout/components/layout';
import Permissions from '@security/permissions';

const PaymentSettingsPage = () =>
import('@modules/subproperty-settings/finantial-settings/components/finantial-settings-page.vue');

export default [
    {
        path: '',
        component: Layout,
        children: [
            {
                name: 'finantialSettings',
                path: '/subproperty/settings/finantial/:tabType?',
                component: PaymentSettingsPage,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.settingsEdit,
                },
                props: true,
            },
        ],
    },
];
